import { useState } from "react";
import { useSearchParams } from "react-router-dom";

const useTableQuery = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const page = Number(searchParams.get("page")) || 1;
  const search = searchParams.get("search") || "";
  const filter = searchParams.get("filter") || "";
  const type = searchParams.get("type") || "";

  const handlePageChange = (page) => {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      params.set("page", page);
      return params;
    });
  };

  const handleSearch = (e) => {
    const value = e.target.value;

    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      params.set("page", 1);

      if (value.trim()) {
        params.set("search", value);
      } else {
        params.delete("search");
      }

      return params;
    });
  };

  const handleFilter = (e) => {
    const filter = e.target.value;
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      params.set("page", 1);

      if (filter.trim()) {
        params.set("filter", filter);
      } else {
        params.delete("filter");
      }
      return params;
    });
  };

  const handleType = (e) => {
    const type = e.target.value;
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      params.set("page", 1);

      if (type.trim()) {
        params.set("type", type);
      } else {
        params.delete("type");
      }
      return params;
    });
  };

  return {
    page,
    search,
    filter,
    type,

    handlePageChange,
    handleSearch,
    handleFilter,
    handleType,

    searchParams,
    setSearchParams,
  };
};

export default useTableQuery;
